import React, { useEffect, useState } from "react";
import "./App.css";
import MainApp from "./app/MainApp";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import useDesktopSize from "./utils/hooks/useDesktopSize";
import useThemeColor from "./utils/hooks/useThemeColor";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { pl } from "date-fns/locale";
import useFakeSession from "./utils/hooks/useFakeSession";
import { useDispatch } from "react-redux";
import { getConfigurationFacility } from "./app/store/config/configActions";
import useFacility from "./utils/hooks/useFacility";
import {
  BIRTHDAY_RESERVATION,
  CALENDAR_SALE,
  CUSTOM_OFFER,
  EVENT_SALE,
  EXERCISE_SCHEDULE,
  GIFT_CARD_ACTIVE,
  LIMITED_TICKET_COLOR,
  LIMITED_TICKET_GROUP,
  LIMITED_TICKET_SHAPE,
  NEWS_PAGE,
  PASSES_SALE,
  REGISTER_B2B,
  TOUR_SALE,
} from "./app/routes";
import CacheBuster from "react-cache-buster";
import { version, homepage } from "../package.json";
import LoadingSpinner from "./features/Loading/LoadingSpinner";
import useColorPalette from "./utils/hooks/useColorPalette";
import ShopError from "./features/Alerts/ShopError";
import { useFacilityIdManager } from "./utils/hooks/useFacilityIdManager";
import { getStepSaleConfig } from "./app/store/stepSaleConfig/saleStepConfigActions";
import { initializeAnaliticsByFacility } from "./utils/Analitics/analiticsConfigByFacility";
import qs from "qs";
import { useManifest } from "./utils/useManifest";
import { ThemeProvider } from "./context/ThemeContext";
import { useNormalizePaymentReturnUrl } from "./utils/hooks/useNormalizePaymentReturnUrl";

const App: React.FC = () => {
  const isProduction = process.env.NODE_ENV === "production";
  const dispatch = useDispatch();
  useNormalizePaymentReturnUrl();
  useFacilityIdManager();
  const facilityIds = useFacility();
  const isDesktop = useDesktopSize();
  const url = window.location.href;
  const [link, setLink] = useState("");
  const [configLoaded, setConfigLoaded] = useState(true);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);
  const b2bToken = qs.parse(window.location.search.slice(1)).B2BSESSION as string;
  useManifest(facilityIds === "1241" ? "1241" : undefined, "#ffffff");

  useEffect(() => {
    initializeAnaliticsByFacility(facilityIds);

    if (b2bToken) {
      const linkValue = `${window.location.pathname}${window.location.search}`;
      setLink(linkValue);
      sessionStorage.setItem("HomePage", linkValue);
    } else {
      if (url) {
        if (url.includes("EventSaleActive")) {
          setLink(EVENT_SALE);
          sessionStorage.setItem("HomePage", link);
        }
        if (url.includes("NewsActive")) {
          setLink(NEWS_PAGE);
          sessionStorage.setItem("HomePage", link);
        }
        if (url.includes("GiftCardActive")) {
          setLink(GIFT_CARD_ACTIVE);
          sessionStorage.setItem("HomePage", link);
        }
        if (url.includes("calendarSale")) {
          setLink(CALENDAR_SALE);
          sessionStorage.setItem("HomePage", link);
        }
        if (url.includes("BirthDaysActive")) {
          setLink(BIRTHDAY_RESERVATION);
          sessionStorage.setItem("HomePage", link);
        }
        if (url.includes("PassSale")) {
          setLink(PASSES_SALE);
          sessionStorage.setItem("HomePage", link);
        }
        if (url.includes("schedule")) {
          setLink(EXERCISE_SCHEDULE);
          sessionStorage.setItem("HomePage", link);
        }
        if (url.includes("ticketsShape")) {
          setLink(LIMITED_TICKET_SHAPE);
          sessionStorage.setItem("HomePage", link);
        }
        if (url.includes("ticketsGroup")) {
          setLink(LIMITED_TICKET_GROUP);
          sessionStorage.setItem("HomePage", link);
        }
        if (url.includes("ticketsColor")) {
          setLink(LIMITED_TICKET_COLOR);
          sessionStorage.setItem("HomePage", link);
        }
        if (url.includes("tours")) {
          setLink(TOUR_SALE);
          sessionStorage.setItem("HomePage", link);
        }
        if (url.includes("customOffer")) {
          setLink(`${CUSTOM_OFFER}${window.location.search}`);
          sessionStorage.setItem("HomePage", link);
        }
        if (url.includes("register-b2b")) {
          setLink(`${REGISTER_B2B}${window.location.search}`);
          sessionStorage.setItem("HomePage", link);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds, b2bToken]);

  useThemeColor();
  useFakeSession();
  useColorPalette();

  useEffect(() => {
    if (Boolean(facilityIds)) {
      dispatch(getConfigurationFacility(facilityIds));
      dispatch(getStepSaleConfig(facilityIds));
      setConfigLoaded(true);
      if (timeoutId) {
        clearTimeout(timeoutId);
        setTimeoutId(null);
      }
    } else {
      const id = setTimeout(() => {
        setConfigLoaded(false);
      }, 5000);

      setTimeoutId(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  return (
    <ThemeProvider>
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction}
      isVerboseMode={false}
      loadingComponent={<LoadingSpinner />}
      metaFileDirectory={`.${homepage}`}
    >
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={pl}>
        <ReactNotification isMobile={!isDesktop} />
        {configLoaded ? <MainApp /> : <ShopError />}
      </MuiPickersUtilsProvider>
    </CacheBuster>
    </ThemeProvider>
  );
};

export default App;
